import React, { useState } from 'react';
import {
  CloseButton,
  Option,
  Container,
  ContainerOptions,
  CustomModal,
} from './styles';
import { Modal } from 'react-bootstrap';
import { FaPrint } from 'react-icons/fa';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Typography } from '@material-ui/core';
import { useImpressaoPedidoVenda } from './ImpressaoPedidoVendaContext';
import { AiOutlineClose } from 'react-icons/ai';
import { toast } from 'react-toastify';

interface IImpressaoPedidoVenda {
  show: boolean;
  handleShow: (show: boolean) => void;
  handlePrint: (option: string | undefined) => Promise<boolean>;
}

const MySwal = withReactContent(Swal);

const ImpressaoPedidoVenda: React.FC<IImpressaoPedidoVenda> = ({
  show,
  handleShow,
  handlePrint,
}: IImpressaoPedidoVenda) => {
  const { isLoading, setIsLoading } = useImpressaoPedidoVenda();
  const [isLoadingImprimir, setIsLoadingImprimir] = useState(false);
  const [selectedOption, setSelectedOption] = useState(undefined);

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
  };

  const handleConfirm = async (option: string) => {
    if (option) {
      setIsLoadingImprimir(true);
      const responsePrint = await handlePrint(option);
      setIsLoadingImprimir(false);

      if (responsePrint) handleShow(false);
      return responsePrint;
    }
    toast.warn('Selecione pelo menos um tipo de impressão.');
  };

  const handleCloseModal = () => {
    handleShow(false);
  };

  return (
    <CustomModal size="lg" show={show} onHide={handleCloseModal} animation>
      <Modal.Header className="d-flex justify-content-between">
        <Modal.Title>Escolha o modelo de impressão</Modal.Title>
        <CloseButton onClick={handleCloseModal}>
          <AiOutlineClose size={24} />
        </CloseButton>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <ContainerOptions>
            <Option
              isSelected={selectedOption === 'A4'}
              onClick={() => handleConfirm('A4')}
              disabled={isLoadingImprimir}
            >
              <FaPrint
                style={{ fontSize: 36, color: '#9C60FF', marginBottom: 10 }}
              />
              <Typography>Sulfite A4</Typography>
            </Option>
            <Option
              isSelected={selectedOption === 'bobina'}
              onClick={() => handleConfirm('bobina')}
              disabled={isLoadingImprimir}
            >
              <FaPrint
                style={{ fontSize: 36, color: '#9C60FF', marginBottom: 10 }}
              />
              <Typography>Bobina contínua</Typography>
            </Option>
            <Option
              isSelected={selectedOption === 'danfe'}
              onClick={() => handleConfirm('danfe')}
              disabled={isLoadingImprimir}
            >
              <FaPrint
                style={{ fontSize: 36, color: '#9C60FF', marginBottom: 10 }}
              />
              <Typography>Danfe NFCe</Typography>
            </Option>
          </ContainerOptions>
        </Container>
      </Modal.Body>
    </CustomModal>
  );
};

export default ImpressaoPedidoVenda;
